/*
  zw-buy-box.js — <zw-buy-box>, riquadro d'acquisto della scheda tessuti.
  Legge il JSON [data-zw-data] reso da snippets/zw-buy-box.liquid e possiede
  tutto il render: colore, rotoli, "quanto ne vuoi", totale, carrello.
  Nessun fetch della sezione al cambio rotolo: i dati dei rotoli sono in pagina.

  Formula prezzi (identica alla Discount Function dell'app Zerow Cut to Size):
    unit = prezzo variante / L (netto, €/m)
    taglio:  m × unit × (1 − promo)
    intero:  L × unit × (1 − min(scontoRotolo + promo, 1))     additivo, cap 100%
  Display IVA da vat-rate (tre stati): disp(x) = x × (1 + pct/100) se incl, altrimenti x.

  Contratti (docs/riquadro-acquisto-rework.md §2.3, §7):
    input[name=id] aggiornato + evento change (BSS legge quello)
    .product-form__submit resta nel DOM (Huski); aria-disabled per "manca la scelta",
      disabled vero solo per "esaurito"
    properties _tipo / _metri_acquistati / _metri_totali, quantity 1 (taglio)
    publish(cartUpdate, {source:'zw-buy-box'}) + cart.renderContents(sections) come product-form
    evento 'variant:change' dopo ogni render (MobileStickyATC ricalcola la soglia)
*/
(function () {
  if (customElements.get('zw-buy-box')) return;

  // lunghezze standard del taglio come pillole (2026-10-29): mostrate solo fra il minimo di taglio e i
  // metri tagliabili. Prima minimo, +5, +10 (1, 6, 11 m) che su un rotolo da 500 m non dicevano niente
  const QUICK_CUT = [3, 5, 10, 25];
  const UPSELL_RATIO = 1.5; // §7: oltre 1,5× il prezzo del taglio niente suggerimento

  const fmtMoney = (n) =>
    (Math.round((n + Number.EPSILON) * 100) / 100).toLocaleString('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + ' €';
  // percentuale come la Discount Function: due decimali (27,5), mai arrotondata all'intero
  const fmtPct = (f) => (Math.round((f + Number.EPSILON) * 10000) / 100).toLocaleString('it-IT', { maximumFractionDigits: 2 });
  // lunghezze sempre con due decimali (spec: "20,40 m")
  // icone del riepilogo totale: rotolo = la stessa immagine della fascia "Qualita' Garantita"
  // (blocco custom_liquid dei template prodotto), metri = righello di snippets/icon-pack.liquid
  // chip rotolo (anche al metro): riga alta = metri + prezzo, riga bassa = disponibilita' + badge carrello
  const chipHtml = ({ cls, attr, len, price, sub, badge }) =>
    `<button type="button" class="${cls}" ${attr}>` +
      `<span class="zw-bb__roll-top"><span class="zw-bb__roll-len">${len}</span><span class="zw-bb__roll-price">${price}</span></span>` +
      // riga bassa sempre presente: tutte le card della griglia hanno la stessa struttura e altezza
      `<span class="zw-bb__roll-bottom"><span class="zw-bb__roll-sub">${sub || ''}</span>${badge ? `<span class="zw-bb__roll-cart">${badge}</span>` : ''}</span>` +
    `</button>`;
  const fmtLen = (n) =>
    (Math.round((n + Number.EPSILON) * 100) / 100).toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 2 }); // "10 m", "12,5 m": i ,00 erano rumore (2026-10-19)
  const tpl = (s, vars) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (k in vars ? vars[k] : m));
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  class ZwBuyBox extends HTMLElement {
    connectedCallback() {
      if (this._init) return; // idempotente (editor del tema ri-monta la sezione)
      this._init = true;
      this.mode = this.dataset.mode;
      if (this.mode === 'sourcing') return; // solo il link al modulo di contatto, niente JS

      const raw = this.querySelector('[data-zw-data]');
      if (!raw) return;
      try {
        this.data = JSON.parse(raw.textContent);
      } catch (e) {
        return;
      }
      const d = this.data;
      this.i18n = d.i18n || {};
      this.vatMult = d.vat && d.vat.incl ? 1 + (d.vat.pct || 0) / 100 : 1;
      this.promo = Math.min(Math.max((d.promoPct || 0) / 100, 0), 1);
      this.effFull = Math.min((d.scontoFrac || 0) + this.promo, 1);
      this.minM = d.minM || 10;
      this.leather = !!d.leather; // pelli: modalita' rotolo intero al pezzo (len = 1 pelle, area in m2)
      this.meterMin = d.meterMin > 0 ? d.meterMin : 5; // al metro: dal setting del blocco / metafield

      this.el = {
        head: this.querySelector('[data-zw-head]'),
        min: this.querySelector('[data-zw-min]'),
        colorName: this.querySelector('[data-zw-color-name]'),
        swatches: this.querySelectorAll('.zw-bb__swatch input'),
        rollsLabel: this.querySelector('[data-zw-rolls-label]'),
        rollsBlock: this.querySelector('[data-zw-rolls]'),
        qtySlot: this.querySelector('[data-zw-qtyslot]'),
        avail: this.querySelector('[data-zw-avail]'),
        rollsMeta: this.querySelector('[data-zw-rolls-meta]'),
        grid: this.querySelector('[data-zw-grid]'),
        rollsNote: this.querySelector('[data-zw-rolls-note]'),
        edit: this.querySelector('[data-zw-edit]'),
        qty: this.querySelector('[data-zw-qty]'),
        msg: this.querySelector('[data-zw-msg]'),
        totalDesc: this.querySelector('[data-zw-total-desc]'),
        totalLabel: this.querySelector('[data-zw-total-label]'),
        totalValue: this.querySelector('[data-zw-total-value]'),
        totalNote: this.querySelector('[data-zw-total-note]'),
        tiersBox: this.querySelector('[data-zw-tiers]'),
        tiers: this.querySelectorAll('[data-zw-tier]'),
        form: this.querySelector('form'),
        inputId: this.querySelector('[data-zw-input-id]'),
        inputQty: this.querySelector('[data-zw-input-qty]'),
        propTipo: this.querySelector('[data-zw-prop-tipo]'),
        propMetri: this.querySelector('[data-zw-prop-metri]'),
        propTotali: this.querySelector('[data-zw-prop-totali]'),
        add: this.querySelector('[data-zw-add]'),
        addLabel: this.querySelector('[data-zw-add-label]'),
      };

      // stato
      this.cart = {}; // variantId -> {key, qty, tipo, metri}
      this.samples = []; // campioni Huski gia' nel carrello: {of: titolo prodotto, variant: "Colore / misura"}
      this.cartReady = false;
      this.state = {
        color: d.initialColor,
        rollId: null, // taglio / rotolo intero: id variante
        choice: 'full', // 'full' | 'part'
        meters: '', // valore del campo metri (stringa)
        metersTouched: false,
        editingKey: null,
        note: '', // riga neutra (cambio automatico del rotolo)
        showAll: false,
        rollQty: 1, // rotolo intero: quanti
      };
      // deep link / "Modifica" dal carrello: ?variant= seleziona il rotolo
      // ?variant= (card, wishlist, "Modifica" dal carrello) fissa il COLORE; il rotolo
      // preselezionato e' sempre il piu' corto libero, tranne quando la variante dell'URL e'
      // gia' nel carrello (si sta modificando quella riga)
      const deep = d.selectedVariant ? this.byId(d.selectedVariant) : null;
      if (deep) this.state.color = deep.color;
      this.bind();
      this.preselect();
      this.render();
      this.fetchCart().then(() => {
        if (deep && this.mode !== 'meter' && this.line(deep)) {
          this.state.rollId = deep.id;
          this.syncVariant(deep);
        } else {
          this.preselect(); // il piu' corto LIBERO, ora che il carrello e' noto
        }
        this.applyCartDefaults();
        this.render();
      });
    }

    // ---------- dati ----------
    byId(id) {
      return this.data.variants.find((v) => String(v.id) === String(id)) || null;
    }
    // un rotolo esiste solo se: giacenza > 0 E lunghezza > 0 E prezzo > 0 E non campione.
    // Non ci si fida di `available` (policy "continua a vendere"), regola gia' in vigore.
    purchasable(v) {
      return !!v && v.qty > 0 && v.len > 0 && v.price > 0 && !v.sample;
    }
    colors() {
      const seen = [];
      this.data.variants.forEach((v) => {
        if (!v.sample && v.color && !seen.includes(v.color)) seen.push(v.color);
      });
      return seen;
    }
    colorAvailable(color) {
      return this.data.variants.some((v) => v.color === color && this.purchasable(v));
    }
    rolls(color) {
      return this.data.variants.filter((v) => v.color === color && this.purchasable(v)).sort((a, b) => a.len - b.len);
    }
    current() {
      return this.state.rollId ? this.byId(this.state.rollId) : null;
    }
    line(v) {
      return v ? this.cart[String(v.id)] || null : null;
    }
    inCart(v) {
      const l = this.line(v);
      return !!(l && l.qty > 0);
    }
    freeRolls(color) {
      return this.rolls(color).filter((v) => !this.inCart(v));
    }
    unit(v) {
      return v && v.len > 0 ? v.price / 100 / v.len : 0;
    }
    rm(v) {
      return this.unit(v) * (1 - this.effFull);
    } // €/m rotolo intero, netto
    tm(v) {
      return this.unit(v) * (1 - this.promo);
    } // €/m al taglio, netto
    // totali netti come al checkout: arrotondamenti di window.zwCheckoutCents (assets/global.js).
    // rm/tm restano per i prezzi al metro indicativi; ogni importo da pagare passa da qui.
    unitsNet(v, q = 1) {
      return (q * window.zwCheckoutCents(v.price, this.effFull * 100)) / 100;
    } // q unita' della variante a percentuale: rotolo intero, rotoli, pelli, metri
    cutNet(v, m) {
      return v.len > 0 ? window.zwCheckoutCents(v.price, this.promo * 100, m, v.len) / 100 : 0;
    } // taglio di m metri dal rotolo v
    disp(x) {
      return x * this.vatMult;
    }
    maxPart(v) {
      return Math.floor(v.len - this.minM);
    }
    partAllowed(v) {
      return !!v && v.len - this.minM >= this.minM;
    }
    maxGlobal(color) {
      return this.freeRolls(color).reduce((m, v) => Math.max(m, this.maxPart(v)), 0);
    }
    // al metro: metri disponibili del colore al netto del carrello
    meterVariant(color) {
      return this.data.variants.find((v) => v.color === color && this.purchasable(v)) || null;
    }
    meterAvail(color) {
      const v = this.meterVariant(color);
      if (!v) return 0;
      const l = this.line(v);
      return Math.max(0, v.qty - (l ? l.qty : 0));
    }
    // al metro: massimo ordinabile = metri ancora disponibili (come i rotoli, si aggiunge; niente modifica)
    meterMax(color) {
      return this.meterAvail(color);
    }
    // al metro: scelte rapide = minimo, x2, x4 (sotto il disponibile) + tutto il metraggio disponibile
    meterQuicks(color) {
      const max = this.meterMax(color);
      const min = this.meterMin;
      if (max < min) return [];
      const out = [min, min * 2, min * 4].filter((n, i, arr) => n < max && arr.indexOf(n) === i);
      out.push(max);
      return out;
    }

    // preselezione (2026-10-15): il rotolo piu' corto disponibile e non nel carrello, cosi'
    // totale e bottone sono subito pronti con il prezzo piu' basso. Al metro il primo rotolo finto.
    preselect() {
      if (this.mode === 'meter') {
        // come i rotoli: parte dalla scelta piu' piccola; quello che e' gia' nel carrello si vede dal badge
        if (!this.state.metersTouched) this.state.meters = this.meterAvail(this.state.color) >= this.meterMin ? String(this.meterMin) : '';
        return;
      }
      const free = this.leather ? this.rolls(this.state.color).filter((r) => r.qty - (this.line(r) ? this.line(r).qty : 0) > 0) : this.freeRolls(this.state.color);
      const pick = free[0] || this.rolls(this.state.color)[0] || null;
      this.state.rollId = pick ? pick.id : null;
      this.state.choice = 'full';
      this.state.editingKey = null;
      if (pick) this.syncVariant(pick);
      // se il rotolo preso e' gia' nel carrello (es. era l'unico), si parte in modifica: il
      // bottone dice "Aggiorna", non "Aggiungi"
      this.applyCartDefaults();
    }
    // ---------- carrello ----------
    async fetchCart() {
      this.cart = {};
      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        this.samples = [];
        (cart.items || []).forEach((item) => {
          const p = item.properties || {};
          if (p['Sample of'] || p._sample_info) {
            this.samples.push({ of: p['Sample of'] || String(p._sample_info || '').replace(/^[^:]*:\s*/, ''), variant: p.Variant || '', sku: p.SKU || '' });
            return;
          }
          const prev = this.cart[String(item.id)];
          // taglio: una riga per rotolo; rotolo intero / al metro: somma le quantita'
          this.cart[String(item.id)] = {
            key: p._metri_acquistati != null || !prev ? item.key : prev.key,
            qty: (prev ? prev.qty : 0) + item.quantity,
            tipo: p._tipo || (prev ? prev.tipo : null),
            metri: p._metri_acquistati != null ? parseFloat(p._metri_acquistati) : prev ? prev.metri : null,
          };
        });
      } catch (e) {
        /* fallback: validazione all'aggiunta */
      }
      this.cartReady = true;
    }
    // "Modifica" dal carrello: la riga del rotolo selezionato precompila la scelta
    applyCartDefaults() {
      const v = this.current();
      if (this.mode !== 'cut' || !v) return;
      const l = this.line(v);
      if (l && l.metri != null) {
        this.state.editingKey = l.key;
        this.state.choice = l.tipo === 'intero' ? 'full' : 'part';
        if (l.tipo !== 'intero') {
          this.state.meters = String(Math.round(l.metri));
          this.state.metersTouched = true;
        }
      }
    }

    // ---------- eventi ----------
    bind() {
      this.el.swatches.forEach((input) =>
        input.addEventListener('change', () => this.setColor(input.value))
      );
      this.addEventListener('click', (e) => {
        const roll = e.target.closest('[data-zw-roll]');
        if (roll && this.contains(roll)) return this.onRollClick(roll.dataset.zwRoll);
        const fake = e.target.closest('[data-zw-fake]');
        if (fake) return this.setFake(parseFloat(fake.dataset.zwFake));
        const choice = e.target.closest('[data-zw-choice]');
        if (choice) return this.setChoice(choice.dataset.zwChoice);
        const step = e.target.closest('[data-zw-step]');
        if (step && !step.disabled) {
          const k = step.dataset.zwStep; // "-1" | "1" (metri) · "qty-" | "qty+" (rotoli)
          return this.step(k, k.endsWith('+') ? 1 : k.endsWith('-') ? -1 : parseInt(k, 10));
        }
        const tierBtn = e.target.closest('[data-zw-tier]');
        if (tierBtn && !tierBtn.disabled) {
          this.state.rollQty = +tierBtn.dataset.zwTier;
          return this.render();
        }
        const quick = e.target.closest('[data-zw-quick]');
        if (quick) return this.setMeters(quick.dataset.zwQuick, true);
        const act = e.target.closest('[data-zw-action]');
        if (act) return this.onAction(act.dataset.zwAction, act.dataset);
      });
      this.addEventListener('input', (e) => {
        // mentre si scrive non si ricostruisce il campo (perderebbe il focus): solo chip, errore, totale
        if (e.target.matches('[data-zw-meters]')) this.setMetersLive(e.target.value);
        if (e.target.matches('[data-zw-rollqty]')) {
          // valore cosi' com'e' scritto (vuoto = 0): se fuori dai limiti il totale va in errore e il
          // pulsante non aggiunge. Prima 0 diventava 1 in silenzio e "Aggiungi" metteva 1 pelle (2026-10-29)
          const n = parseInt(e.target.value, 10);
          this.state.rollQty = isNaN(n) ? 0 : n;
          this.renderTotal();
        }
      });
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-zw-meters]')) this.setMeters(e.target.value, true);
      });
      this.el.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submit();
      });
      // sync col carrello (drawer, pagina carrello, altre schede)
      const sync = () =>
        this.fetchCart().then(() => {
          this.reconcileSelection();
          this.render();
        });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
          if (ev && ev.source === 'zw-buy-box') return; // i nostri eventi: gia' sincronizzati
          sync();
        });
      }
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) sync();
      });
      // rete di sicurezza: le righe campione nel drawer le tocca Huski con il suo script, senza
      // cartUpdate. Qualunque mutazione del drawer (riga tolta, apertura, chiusura) → rilettura.
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        let t = null;
        const mo = new MutationObserver(() => {
          clearTimeout(t);
          t = setTimeout(sync, 400);
        });
        mo.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }
      window.addEventListener('pageshow', (e) => {
        if (e.persisted) sync();
      });
    }
    setColor(color) {
      if (color === this.state.color) return;
      // cambio colore = si azzera tutto (spec §4)
      this.state.color = color;
      this.state.rollId = null;
      this.state.editingKey = null;
      this.state.choice = 'full';
      this.state.meters = '';
      this.state.metersTouched = false;
      this.state.note = '';
      this.state.showAll = false;
      const first = this.rolls(color)[0] || this.meterVariant(color) || this.data.variants.find((v) => v.color === color);
      this.syncVariant(first);
      this.preselect();
      this.render();
    }
    onRollClick(id) {
      const v = this.byId(id);
      if (!v) return;
      if (this.mode === 'cut') {
        const l = this.line(v);
        if (l && l.metri != null) {
          // rotolo gia' nel carrello → modalita' modifica (spec §10.1)
          this.state.rollId = v.id;
          this.state.editingKey = l.key;
          this.state.choice = l.tipo === 'intero' ? 'full' : 'part';
          this.state.meters = l.tipo === 'intero' ? '' : String(Math.round(l.metri));
          this.state.metersTouched = l.tipo !== 'intero';
          this.state.note = '';
        } else {
          if (this.state.editingKey) this.toast(this.i18n.editCancelled);
          this.state.note = '';
          this.state.editingKey = null;
          this.state.rollId = v.id;
          this.state.choice = 'full'; // spec §5.1: preselezionato "Tutto il rotolo"
          if (!this.partAllowed(v)) this.state.choice = 'full';
          // il cliente ha scelto lui il rotolo: i metri scritti restano, l'errore lo dice §6.3
        }
      } else {
        this.state.rollId = v.id;
        this.state.rollQty = Math.max(this.state.rollQty, this.data.minQty || 1);
      }
      this.syncVariant(v);
      this.render();
    }
    setFake(len) {
      this.state.meters = String(Math.round(len));
      this.state.metersTouched = true;
      this.state.note = '';
      this.render();
    }
    setChoice(c) {
      const v = this.current();
      if (c === 'part' && this.mode === 'cut' && !this.partAllowed(v)) return;
      this.state.choice = c;
      if (c === 'part' && this.mode === 'cut' && !this.state.metersTouched) this.state.meters = String(this.minM);
      this.render();
    }
    // −/+ accanto al campo: metri (taglio e al metro) o rotoli (rotolo intero)
    step(kind, delta) {
      if (String(kind).startsWith('qty')) {
        const v = this.current();
        const l = this.line(v);
        const left = v ? Math.max(0, v.qty - (l ? l.qty : 0)) : 0;
        const minQ = this.data.minQty || 1;
        this.state.rollQty = Math.min(Math.max((this.state.rollQty || minQ) + delta, minQ), Math.max(left, minQ));
        this.render();
        return;
      }
      const cur = parseInt(this.state.meters, 10);
      const base = isNaN(cur) ? (this.mode === 'meter' ? this.meterMin : this.minM) - delta : cur;
      this.setMeters(String(Math.max(1, base + delta)), true);
    }
    setMetersLive(val) {
      this.state.meters = String(val).replace(/[^\d]/g, '');
      this.state.metersTouched = true;
      this.state.note = '';
      const box = this.el.qty.querySelector('.zw-bb__meters');
      if (box) {
        const val2 = this.validateMeters();
        const m = parseInt(this.state.meters, 10);
        let isQuick = false;
        box.querySelectorAll('[data-zw-quick]').forEach((chip) => {
          const on = parseInt(chip.dataset.zwQuick, 10) === m;
          if (on) isQuick = true;
          chip.classList.toggle('is-selected', on);
        });
        box.classList.toggle('is-error', !!val2.error);
        box.classList.toggle('is-custom', !val2.error && !isQuick && this.state.meters !== '');
        let err = box.querySelector('.zw-bb__error');
        if (val2.error) {
          if (!err) {
            err = document.createElement('p');
            err.className = 'zw-bb__error';
            box.querySelector('.zw-bb__meters-row').insertAdjacentElement('afterend', err);
          }
          err.textContent = val2.error;
        } else if (err) {
          err.remove();
        }
      }
      this.renderTotal();
    }
    setMeters(val, commit) {
      this.state.meters = String(val).replace(/[^\d]/g, '');
      this.state.metersTouched = true;
      this.state.note = '';
      if (commit) this.autoSwitch();
      this.render();
    }
    // §6.3: metri oltre il massimo del rotolo scelto → passa al rotolo libero piu' corto che basta
    autoSwitch() {
      const m = parseInt(this.state.meters, 10);
      if (!m) return;
      if (this.mode === 'cut') {
        const v = this.current();
        if (!v || m <= this.maxPart(v)) return;
        const cand = this.freeRolls(this.state.color).find((r) => this.maxPart(r) >= m);
        if (cand) {
          this.state.note = tpl(this.i18n.switched, { meters: m, new: fmtLen(cand.len) }) // dai metri chiesti: il massimo del rotolo non e' piu' a schermo (2026-10-28);
          this.state.rollId = cand.id;
          this.state.editingKey = null;
          this.syncVariant(cand);
        }
      }
    }
    // una riga sparita dal carrello mentre eravamo in modifica → torna a scelta normale
    reconcileSelection() {
      if (this.state.editingKey) {
        const v = this.current();
        const l = this.line(v);
        if (!l || l.key !== this.state.editingKey) {
          this.state.editingKey = null;
        }
      }
    }
    onAction(action, ds) {
      if (action === 'cancel-edit') {
        this.state.editingKey = null;
        this.state.rollId = null;
        this.state.meters = '';
        this.state.metersTouched = false;
        this.render();
      } else if (action === 'remove-line') {
        this.removeLine();
      } else if (action === 'take-roll') {
        const v = this.byId(ds.zwId);
        if (!v) return;
        this.state.rollId = v.id;
        this.state.editingKey = null;
        this.state.choice = 'full';
        this.state.note = '';
        this.syncVariant(v);
        this.render();
      } else if (action === 'cut-from') {
        const v = this.byId(ds.zwId);
        if (!v) return;
        this.state.rollId = v.id;
        this.state.editingKey = null;
        this.state.choice = 'part';
        this.state.note = '';
        this.syncVariant(v);
        this.render();
      } else if (action === 'show-all') {
        this.state.showAll = true;
        this.render();
      }
    }

    // variante corrente nel form + URL + foto (al posto del fetch della sezione di Dawn)
    syncVariant(v) {
      if (!v) return;
      if (this.el.inputId && String(this.el.inputId.value) !== String(v.id)) {
        this.el.inputId.value = v.id;
        this.el.inputId.dispatchEvent(new Event('change', { bubbles: true })); // BSS ascolta questo
      }
      // Huski (campione) NON legge input[name=id]: al cambio variante e al click prende
      // ShopifyAnalytics.meta.selectedVariantId e, se manca (pagina aperta senza ?variant=),
      // la PRIMA variante del prodotto (_0x38d894 / getSelectedVariantTitle del suo script):
      // campione segnato con colore e SKU del primo colore. Si aggiornano i tre globali che
      // legge: l'id di Shopify, il suo id (titolo della riga) e lo SKU (property "SKU").
      try {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta) window.ShopifyAnalytics.meta.selectedVariantId = String(v.id);
        window.selectedVariantId = String(v.id);
        if (v.sku) window.skucode = v.sku;
      } catch (e) {
        /* niente */
      }
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* niente */
      }
      if (v.media) {
        document.querySelectorAll('.product__media-wrapper').forEach((wrap) => {
          const st = window.getComputedStyle(wrap);
          if (st.display === 'none' || st.visibility === 'hidden') return;
          const slide = wrap.querySelector(`[data-media-id="${this.data.sectionId}-${v.media}"]`);
          const list = wrap.querySelector('.js-media-list');
          if (slide && list && list.swiper) {
            const idx = list.swiper.slides.indexOf(slide);
            if (idx >= 0) list.swiper.slideTo(idx);
          } else if (slide) {
            // galleria impilata (static_column_aside): sotto i 1200px la lista scorre in
            // orizzontale → porta la foto del colore in vista; su desktop sono tutte visibili
            const stack = slide.closest('.product__media-list');
            if (stack && window.matchMedia('(max-width: 1199px)').matches) {
              stack.scrollTo({ left: slide.offsetLeft - stack.offsetLeft, behavior: 'smooth' });
            }
          }
        });
      }
    }

    // ---------- validazione ----------
    // ritorna {m, error, suggest} per la scelta "solo una parte"
    validateMeters() {
      const raw = this.state.meters;
      const m = parseInt(raw, 10);
      const color = this.state.color;
      if (raw === '' || isNaN(m)) return { m: null, error: this.i18n.errEmpty };
      if (this.mode === 'meter') {
        const max = this.meterMax(color);
        if (m < this.meterMin) return { m, error: tpl(this.i18n.errMin, { min: this.meterMin }) };
        if (m > max) return { m, error: tpl(this.i18n.errMaxMeters, { max: fmtLen(max) }) };
        return { m, error: null };
      }
      const v = this.current();
      if (!v) return { m, error: null };
      if (m < this.minM) return { m, error: tpl(this.i18n.errMin, { min: this.minM }) };
      const max = this.maxPart(v);
      if (m > max) {
        const cand = this.freeRolls(color).find((r) => this.maxPart(r) >= m);
        if (cand) {
          return { m, error: tpl(this.i18n.errMaxRoll, { max }), suggest: { kind: 'roll', cand, m } };
        }
        const whole = this.freeRolls(color).find((r) => r.len >= m);
        return { m, error: tpl(this.i18n.errMaxGlobal, { max: this.maxGlobal(color) }), suggest: whole ? { kind: 'whole', cand: whole, m } : null };
      }
      return { m, error: null };
    }

    // §7: rotolo intero al posto del taglio, solo se conviene davvero
    upsell(v, m) {
      if (this.mode !== 'cut' || !v || !m) return null;
      const cp = this.cutNet(v, m);
      const cand = this.freeRolls(this.state.color).find((r) => r.len >= m);
      if (!cand) return null;
      const wp = this.unitsNet(cand);
      const more = cand.len - m;
      let text;
      if (wp <= cp) {
        text = more <= 0.05
          ? tpl(this.i18n.upsellSaveOnly, { amount: fmtMoney(this.disp(cp - wp)) })
          : tpl(this.i18n.upsellSave, { meters: fmtLen(cand.len), more: fmtLen(more), amount: fmtMoney(this.disp(cp - wp)) });
      } else if (wp <= UPSELL_RATIO * cp) {
        text = tpl(this.i18n.upsellPay, { meters: fmtLen(cand.len), more: fmtLen(more), amount: fmtMoney(this.disp(wp - cp)) });
      } else {
        return null;
      }
      return { cand, text };
    }

    // totale netto della scelta corrente, o null se non valida
    // sconto pelli a fasce (2026-11-02): percentuale della fascia piu' alta raggiunta da q pelli.
    // ponytail: conta solo le pelli scelte qui; Shopify conta tutte le pelli del carrello, quindi
    // al checkout lo sconto puo' solo essere uguale o piu' alto
    tierPct(q) {
      let pct = 0;
      this.el.tiers.forEach((b) => {
        if (q >= +b.dataset.zwTier) pct = Math.max(pct, +b.dataset.zwTierPct);
      });
      return pct;
    }
    renderTiers() {
      const box = this.el.tiersBox;
      if (!box) return;
      const v = this.current();
      const l = this.line(v);
      const left = v ? Math.max(0, v.qty - (l ? l.qty : 0)) : 0;
      const base = this.effFull * 100;
      const q = this.state.rollQty || 1;
      let shown = 0;
      let sel = null;
      this.el.tiers.forEach((b) => {
        const min = +b.dataset.zwTier;
        const pct = +b.dataset.zwTierPct;
        // una fascia che non batte la promo a tag non cambia il prezzo: non si mostra
        // ...e nemmeno una che le pelli disponibili non raggiungono
        b.hidden = (pct > 0 && pct <= base) || min > left;
        if (b.hidden) return;
        if (pct > 0) shown++;
        b.classList.remove('is-selected');
        if (q >= min) sel = b;
        const price = b.querySelector('[data-zw-tier-price]');
        if (v) price.textContent = fmtMoney(this.disp(window.zwCheckoutCents(v.price, Math.max(base, pct)) / 100)) + this.i18n.headPiece;
      });
      if (sel) sel.classList.add('is-selected');
      // niente da scegliere: nessuna fascia utile o raggiungibile
      box.hidden = !v || !shown;
    }
    computeTotal() {
      const i = this.i18n;
      if (this.mode === 'meter') {
        const v = this.meterVariant(this.state.color);
        if (!v) return null;
        const { m, error } = this.validateMeters();
        if (error) return { error };
        const net = this.unitsNet(v, m);
        return { net, desc: tpl(i.totalMeters, { meters: fmtLen(m) }), m, variant: v, qty: m };
      }
      const v = this.current();
      if (!v) return null;
      if (this.mode === 'roll') {
        const l = this.line(v);
        const left = Math.max(0, v.qty - (l ? l.qty : 0));
        const raw = this.state.rollQty;
        if (this.leather) {
          if (!(raw >= (this.data.minQty || 1))) return { error: i.chooseHide };
          if (raw > left) return { error: left === 1 ? i.hideAvailableOne : tpl(i.hidesAvailable, { count: left }) };
        } else {
          if (!(raw >= (this.data.minQty || 1))) return { error: i.chooseRoll };
          if (raw > left) return { error: left === 1 ? i.availableOne : tpl(i.rollsAvailable, { count: left }) };
        }
        const q = Math.max(1, this.state.rollQty || 1);
        const desc = this.leather
          ? (q === 1 ? i.totHideOne : tpl(i.totHides, { count: q }))
          : q > 1 ? tpl(i.totalRolls, { count: q, meters: fmtLen(v.len) }) : tpl(i.totalFull, { meters: fmtLen(v.len) });
        // pelli a fasce: su ogni riga Shopify applica lo sconto prodotto piu' alto, promo a tag o fascia
        const tier = this.leather ? this.tierPct(q) : 0;
        if (tier > this.effFull * 100) {
          return { net: (q * window.zwCheckoutCents(v.price, tier)) / 100, full: this.unitsNet(v, q), desc, variant: v, qty: q };
        }
        return { net: this.unitsNet(v, q), desc, variant: v, qty: q };
      }
      // cut
      if (this.state.choice === 'full' || !this.partAllowed(v)) {
        return { net: this.unitsNet(v), desc: tpl(i.totalFull, { meters: fmtLen(v.len) }), variant: v, tipo: 'intero', metri: v.len };
      }
      const { m, error } = this.validateMeters();
      if (error) return { error };
      return { net: this.cutNet(v, m), desc: tpl(i.totalPart, { meters: m, roll: fmtLen(v.len) }), variant: v, tipo: 'taglio', metri: m };
    }

    // variante su cui si basa il campione (lo legge <zw-sample>, assets/zw-sample.js):
    // la scelta corrente, altrimenti il primo rotolo libero del colore / la variante al metro
    sampleVariant() {
      return this.mode === 'meter' ? this.meterVariant(this.state.color) : this.current() || this.rolls(this.state.color)[0];
    }
    // Galleria impilata (static_column_aside): le foto legate a una variante si mostrano solo
    // per il colore scelto; le foto generiche (trama, dettagli) sempre. Senza questo un
    // prodotto a 8 colori impila 8 foto di colore.
    filterGallery() {
      const outer = document.querySelector('.product__outer--static-column-aside');
      if (!outer) return;
      const mine = new Set();
      const others = new Set();
      this.data.variants.forEach((v) => {
        if (!v.media) return;
        (v.color === this.state.color ? mine : others).add(String(v.media));
      });
      let changed = false;
      outer.querySelectorAll('.product__media-list .product__media-item[data-media-id]').forEach((item) => {
        const id = String(item.dataset.mediaId || '').split('-').pop();
        const hide = others.has(id) && !mine.has(id);
        if (item.hidden !== hide) {
          item.hidden = hide;
          changed = true;
        }
      });
      if (changed) document.dispatchEvent(new CustomEvent('zw:gallery:filter'));
    }
    // ---------- render ----------
    render() {
      this.filterGallery();
      this.renderHead();
      this.renderMin();
      this.renderColors();
      this.renderRolls();
      this.renderEdit();
      this.renderQty();
      this.renderTotal();
      document.dispatchEvent(new CustomEvent('variant:change')); // <zw-sample> si riallinea qui
    }
    // ordine minimo del taglio per il colore scelto: se nessun rotolo libero si taglia (partAllowed),
    // il minimo e' il rotolo intero piu' corto. Gemello del calcolo Liquid in zw-buy-box.liquid
    renderMin() {
      const el = this.el.min;
      if (!el || this.mode !== 'cut') return;
      const rolls = this.freeRolls(this.state.color);
      if (!rolls.length) return;
      el.textContent = rolls.some((r) => this.partAllowed(r))
        ? `${fmtLen(this.minM)} m`
        : tpl(this.i18n.fullRoll, { meters: fmtLen(rolls[0].len) }); // rolls() e' gia' ordinato per lunghezza
    }
    renderHead() {
      const i = this.i18n;
      const el = this.el.head;
      if (!el) return;
      const badge = (pct) => (pct > 0 ? `<span class="zw-bb__badge">−${pct}%</span>` : '');
      let v = this.current();
      if (this.mode === 'meter') v = this.meterVariant(this.state.color);
      if (!v) v = this.rolls(this.state.color)[0] || this.data.variants.find((x) => this.purchasable(x));
      if (!v) {
        el.innerHTML = '';
        return;
      }
      // due righe (riferimento 2026-10-16): 1) prezzo grande + unita' + IVA; 2) vecchio barrato
      // (o "a rotolo intero ...") + badge. Il secondo rigo c'e' solo con uno sconto.
      const vat = `<span class="zw-bb__vat">${esc(i.vatNote)}</span>`;
      const br = '<span class="zw-bb__head-br" aria-hidden="true"></span>';
      let html;
      if (this.mode === 'cut') {
        // riferimento unico = prezzo pieno al metro. Riga 1: al taglio (promo da tag: arancio,
        // barrato, badge). Riga 2: rotolo intero in grigio, lo sconto lo dice la card sotto
        const pp = Math.round(this.promo * 100);
        html = `<span class="zw-bb__price${pp > 0 ? ' is-sale' : ''}">${fmtMoney(this.disp(this.tm(v)))}</span><span class="zw-bb__price-unit">${esc(i.headMeterLong || i.headMeter)}</span>` +
          (pp > 0 ? `<s class="zw-bb__price-old">${fmtMoney(this.disp(this.unit(v)))}${esc(i.headMeter)}</s>${badge(pp)}` : '') + vat;
        // "a rotolo intero" solo se costa meno del taglio (al centesimo mostrato, 2026-10-29): uguale e' rumore
        const full = fmtMoney(this.disp(this.rm(v)));
        if (full !== fmtMoney(this.disp(this.tm(v)))) html += br + `<span class="zw-bb__price-cut">${esc(tpl(i.headFull, { price: full }))}</span>`;
      } else {
        const pct = Math.round(this.promo * 100);
        let now;
        let was;
        if (this.mode === 'meter') {
          now = this.unitsNet(v) / (v.len || 1);
          was = this.unit(v);
        } else {
          const rolls = this.rolls(this.state.color);
          now = rolls.reduce((mm, r) => Math.min(mm, this.unitsNet(r) / (r.len || 1)), this.unitsNet(v) / (v.len || 1));
          was = rolls.reduce((mm, r) => Math.min(mm, this.unit(r)), this.unit(v));
        }
        const unit = esc(this.leather ? i.headPiece : this.mode === 'meter' ? i.headMeter : i.headFrom);
        // accanto al prezzo grande l'unita' in parole ("al metro", "a pelle" = headPerHide senza la cifra); il barrato tiene "/m"
        const unitLong = this.leather ? esc(i.headPerHide.replace('{price}', '').trim()) : esc(i.headMeterLong || i.headMeter);
        // pelli con superficie (2026-10-29): sulla stessa riga, dopo un divisore, il prezzo al m2
        const area = this.leather && this.data.showArea ? (v.area || 0) : 0;
        const sqm = area > 0 ? `<span class="zw-bb__price-sqm">${fmtMoney(this.disp(now / area))}${esc(i.headSqm)}</span>` : '';
        html = `<span class="zw-bb__price${pct > 0 ? ' is-sale' : ''}">${fmtMoney(this.disp(now))}</span><span class="zw-bb__price-unit">${unitLong}</span>${sqm}${vat}` +
          (pct > 0 ? br + `<s class="zw-bb__price-old">${fmtMoney(this.disp(was))}${unit}</s>${badge(pct)}` : '');
      }
      el.innerHTML = html;
    }
    renderColors() {
      if (this.el.colorName) this.el.colorName.textContent = this.state.color || '';
      this.el.swatches.forEach((input) => {
        const label = input.closest('.zw-bb__swatch');
        const on = input.value === this.state.color;
        input.checked = on;
        label.classList.toggle('is-selected', on);
        label.classList.toggle('is-soldout', !this.colorAvailable(input.value));
      });
    }
    renderRolls() {
      const i = this.i18n;
      const color = this.state.color;
      const grid = this.el.grid;
      const note = this.el.rollsNote;
      if (this.mode === 'meter') {
        const v = this.meterVariant(color);
        const avail = this.meterAvail(color);
        if (this.el.rollsLabel) this.el.rollsLabel.textContent = i.chooseMeters;
        const l = this.line(v);
        const cur = parseInt(this.state.meters, 10);
        const quicks = this.meterQuicks(color);
        // "N m nel carrello": sul chip che coincide con la quantita' presa, altrimenti nella riga
        // dell'etichetta, accanto ai disponibili (stessa pillola verde dei rotoli)
        const onChip = l && l.qty > 0 && quicks.includes(l.qty);
        // i metri disponibili stanno nella pillola della riga Colore (2026-10-29); qui solo "N m nel carrello"
        this.renderAvailM(avail);
        this.el.rollsMeta.innerHTML = l && l.qty > 0 && !onChip ? `<span class="zw-bb__roll-cart zw-bb__roll-cart--meta">${esc(tpl(i.inCartMeters, { meters: fmtLen(l.qty) }))}</span>` : '';
        const max = this.meterMax(color);
        grid.innerHTML = quicks
          .map((n) => chipHtml({
            cls: 'zw-bb__roll' + (cur === n ? ' is-selected' : ''),
            attr: `data-zw-fake="${n}"`,
            len: fmtLen(n) + ' m',
            price: fmtMoney(this.disp(this.unitsNet(v, n))),
            sub: n === max ? esc(i.allMeters) : '',
            badge: l && l.qty === n ? esc(tpl(i.inCartMeters, { meters: fmtLen(l.qty) })) : '',
          }))
          .join('');
        if (this.state.note) {
          note.hidden = false;
          note.className = 'zw-bb__note';
          note.textContent = this.state.note;
        } else {
          note.hidden = true;
        }
        return;
      }
      const rolls = this.rolls(color);
      if (this.leather) {
        // una sola variante per colore (il caso normale): niente scelta, il blocco sparisce
        if (this.el.rollsBlock) this.el.rollsBlock.hidden = rolls.length <= 1;
        if (this.el.rollsLabel) this.el.rollsLabel.textContent = i.sizeLabel;
      } else if (this.el.rollsBlock) {
        // taglio con un rotolo solo (fuori dal carrello): niente da scegliere, la lunghezza e' gia' in
        // "Tutto il rotolo, 456 m" (2026-10-29; prima un chip solo e "1 rotoli disponibili")
        this.el.rollsBlock.hidden = this.mode === 'cut' && rolls.length === 1 && !this.inCart(rolls[0]);
      }
      // metri che RESTANO fuori dal carrello: nella pillola della riga Colore (tessuti, 2026-10-29)
      const leftM = rolls.reduce((s, r) => s + r.len * Math.max(0, r.qty - (this.line(r) ? this.line(r).qty : 0)), 0);
      if (!this.leather) this.renderAvailM(leftM);
      if (this.mode === 'cut') {
        const freeN = rolls.filter((r) => !this.inCart(r)).length;
        this.el.rollsMeta.textContent = freeN === 1 ? i.availableOne : tpl(i.rollsAvailable, { count: freeN }); // niente "1 rotoli disponibili"
      } else {
        // se e' tutto nel carrello lo dice; i metri disponibili dei tessuti sono nella pillola
        const inCartAny = rolls.some((r) => this.inCart(r));
        const leftA = rolls.reduce((s, r) => s + this.hideArea(r, Math.max(0, r.qty - (this.line(r) ? this.line(r).qty : 0))), 0);
        this.el.rollsMeta.textContent = leftM <= 0 && inCartAny ? i.allInCart : this.leather ? (leftA > 0 ? this.hideAvail(leftM, leftA) : tpl(i.availableN, { count: leftM })) : '';
      }
      const LIMIT = 12;
      const list = this.state.showAll || rolls.length <= LIMIT ? rolls : rolls.slice(0, LIMIT);
      grid.innerHTML = list
        .map((v) => {
          const sel = String(v.id) === String(this.state.rollId);
          const l = this.line(v);
          const price = fmtMoney(this.disp(this.unitsNet(v)));
          let sub = '';
          let badge = '';
          let cls = 'zw-bb__roll';
          if (this.mode === 'cut') {
            if (l && l.qty > 0) {
              cls += ' is-incart';
              // taglio: dice quanti metri ("20,00 m nel carrello"), non "nel carrello" come fosse tutto il rotolo
              badge = l.tipo === 'taglio' && l.metri ? esc(tpl(i.inCartMeters, { meters: fmtLen(l.metri) })) : esc(i.inCart);
            }
          } else {
            const left = Math.max(0, v.qty - (l ? l.qty : 0));
            const taken = l && l.qty > 0;
            // "1 rotolo disponibile" in rosso quando ne resta uno; "Disponibilita': N" altrimenti;
            // niente "Disponibilita': 0" se e' tutto nel carrello (lo dice il badge)
            // stessa forma ovunque (2026-10-19): "20 disponibili", "1 disponibile"
            sub = left <= 0 && taken ? '' : this.availText(left, this.hideArea(v, left));
            if (taken) {
              badge = esc(tpl(i.inCartN, { count: l.qty }));
              cls += ' is-incart'; // verde, testo pieno: e' tuo, non e' esaurito
            } else if (left <= 0) {
              cls += ' is-disabled';
            }
          }
          if (sel) cls += ' is-selected';
          return chipHtml({ cls, attr: `data-zw-roll="${v.id}" ${cls.includes('is-disabled') ? 'disabled' : ''}`, len: this.leather ? esc(v.value || '') : fmtLen(v.len) + ' m', price, sub, badge });
        })
        .join('');
      if (list.length < rolls.length) {
        grid.insertAdjacentHTML('beforeend', `<button type="button" class="zw-bb__roll zw-bb__roll--more" data-zw-action="show-all">${esc(tpl(i.showAll, { count: rolls.length }))}</button>`);
      }
      if (this.state.note) {
        note.hidden = false;
        note.className = 'zw-bb__note';
        note.textContent = this.state.note;
      } else {
        note.hidden = true;
      }
    }
    // "N disponibili", e "1 disponibile" evidenziato quando ne resta uno (HTML gia' escapato)
    // pelli con superficie (2026-10-20): "12,5 m², 5 pelli disponibili"; area = m² totali
    availText(n, area) {
      const i = this.i18n;
      const txt = area > 0 ? this.hideAvail(n, area) : n === 1 ? i.availableOne : tpl(i.availableN, { count: n });
      return n === 1 ? `<span class="zw-bb__roll-last">${esc(txt)}</span>` : esc(txt);
    }
    // pelli (2026-10-29): disponibilita' del colore nella riga Colore, "29 pelli disponibili (40,6 m²)". Gemello del Liquid
    renderAvail(n, area) {
      const el = this.el.avail;
      if (!el) return;
      el.hidden = n <= 0;
      if (n <= 0) return;
      const i = this.i18n;
      // poche pelli (soglia lowStock dal Liquid): "Solo 3 pelli" in arancio, se no "29 pelli disponibili"
      const low = n <= (this.data.lowStock || 0);
      el.classList.toggle('is-low', low);
      const txt = low
        ? `${i.availableLowLabel} ${n === 1 ? i.totHideOne : tpl(i.totHides, { count: n })}`
        : n === 1 ? i.hideAvailableOne : tpl(i.hidesAvailable, { count: n });
      el.innerHTML = `<strong>${esc(txt)}</strong>` + (area > 0 ? ` (${fmtLen(area)} m²)` : '');
    }
    // tessuti (2026-10-29): metri disponibili del colore nella stessa pillola della riga Colore
    renderAvailM(m) {
      const el = this.el.avail;
      if (!el || this.leather) return;
      el.hidden = m <= 0;
      if (m <= 0) return;
      el.innerHTML = `<strong>${esc(tpl(this.i18n.metersAvailable, { meters: fmtLen(m) }))}</strong>`;
    }
    hideAvail(n, area) {
      const i = this.i18n;
      return tpl(i.availableArea, { area: fmtLen(area), hides: n === 1 ? i.hideAvailableOne : tpl(i.hidesAvailable, { count: n }) });
    }
    // m² di n pelli della variante; 0 se non e' una pelle o la superficie e' nascosta (tag hide_dimensione)
    hideArea(v, n) {
      return this.leather && this.data.showArea && v ? (v.area || 0) * n : 0;
    }
    renderEdit() {
      // nessuna barra "Stai modificando" (tolta 2026-10-16): la modifica si capisce dal chip
      // verde e dal bottone "Aggiorna il carrello". La riga si rimuove dal carrello.
      this.el.edit.hidden = true;
      this.el.edit.innerHTML = '';
    }
    renderQty() {
      const el = this.el.qty;
      const i = this.i18n;
      const st = this.state;
      if (this.mode === 'roll') {
        // pelli e rotoli interi (2026-10-30): stepper compatto accanto al bottone, nessun blocco a parte
        el.hidden = true;
        el.innerHTML = '';
        const slot = this.el.qtySlot;
        if (!slot) return;
        const v = this.current();
        const l = this.line(v);
        const left = v ? Math.max(0, v.qty - (l ? l.qty : 0)) : 0;
        const minQ = this.data.minQty || 1;
        if (this.leather) this.renderAvail(left, this.hideArea(v, left));
        if (!v || left <= 0) {
          slot.hidden = true;
          slot.innerHTML = '';
          return;
        }
        st.rollQty = Math.min(Math.max(st.rollQty || minQ, minQ), left);
        const q = st.rollQty;
        // un pezzo solo (o solo il minimo): niente da scegliere, il pulsante prende la riga (2026-10-30).
        // Il taglio non passa di qui: non ha selettore
        if (left <= minQ) {
          slot.hidden = true;
          slot.innerHTML = '';
          return;
        }
        slot.hidden = false;
        // selettore gia' in pagina: si aggiorna sul posto. Ricostruirlo a ogni − / + sostituiva il
        // pulsante premuto, che perdeva il suo stato premuto e il focus: a schermo cambiava solo il −
        // che si riaccendeva (2026-10-30)
        const box = slot.querySelector('.zw-bb__qtystep');
        if (box) {
          const inp = box.querySelector('[data-zw-rollqty]');
          inp.min = minQ;
          inp.max = left;
          if (document.activeElement !== inp) inp.value = q;
          box.querySelector('[data-zw-step="qty-"]').disabled = q <= minQ;
          box.querySelector('[data-zw-step="qty+"]').disabled = q >= left;
          return;
        }
        // solo il selettore, nella riga del Totale (2026-10-29): etichetta "Numero di pelli" tolta (resta
        // come aria-label del gruppo) e disponibilita' nell'etichetta sotto il prezzo (renderAvail)
        slot.innerHTML =
          `<div class="zw-bb__qtystep" role="group" aria-label="${esc(this.leather ? i.hidesCount : i.rollsCount)}">` +
          `<button type="button" class="zw-bb__qtystep-btn" data-zw-step="qty-" aria-label="−" ${q <= minQ ? 'disabled' : ''}>−</button>` +
          `<input type="number" inputmode="numeric" min="${minQ}" max="${left}" step="1" value="${q}" data-zw-rollqty aria-label="${esc(this.leather ? i.hides : i.rollsCount)}">` +
          `<button type="button" class="zw-bb__qtystep-btn" data-zw-step="qty+" aria-label="+" ${q >= left ? 'disabled' : ''}>+</button></div>`;
        return;
      }
      if (this.mode === 'meter') {
        const v = this.meterVariant(st.color);
        if (!v || this.meterMax(st.color) <= 0) {
          el.hidden = true;
          el.innerHTML = '';
          return;
        }
        // un passaggio solo: il campo metri sotto le scelte rapide (niente "tutto il rotolo / una parte")
        const val = validateOrEmpty(this);
        el.hidden = false;
        // campo metri come un chip largo sotto le scelte rapide (stesso bordo e raggio)
        el.innerHTML = this.metersField(val, this.meterQuicks(st.color), '').replace('class="zw-bb__meters', 'class="zw-bb__meters zw-bb__meters--chip');
        return;
      }
      // cut
      const v = this.current();
      if (!v) {
        el.hidden = true;
        el.innerHTML = '';
        return;
      }
      const canPart = this.partAllowed(v);
      const val = validateOrEmpty(this);
      const quick = QUICK_CUT.filter((n) => n >= this.minM && (n <= this.maxPart(v) || this.freeRolls(st.color).some((r) => this.maxPart(r) >= n)));
      const hasPct = this.effFull > 0;
      const pct = fmtPct(this.effFull);
      // prezzo pieno barrato (L × TM) come nel prototipo: vedi spec §14.4 (Omnibus), si toglie da qui.
      // Al metro: "7,32 €/m" + pieno barrato, stesso stile della riga "Solo una parte" (2026-10-28, prima
      // "invece di" a parole in ink semi-grassetto)
      // €/m sotto le due opzioni solo se diversi dal prezzo in alto (rotolo intero scontato): uguali erano
      // ripetuti tre volte (2026-10-29)
      const sameM = fmtMoney(this.disp(this.rm(v))) === fmtMoney(this.disp(this.tm(v)));
      const fullSub = sameM && !hasPct ? '' : esc(tpl(i.perMeter, { price: fmtMoney(this.disp(this.rm(v))) })) +
        (hasPct ? ` <s>${esc(tpl(i.perMeter, { price: fmtMoney(this.disp(this.unit(v))) }))}</s>` : '');
      const full = this.choiceRow('full', tpl(i.fullRoll, { meters: fmtLen(v.len) }), fullSub,
        { value: fmtMoney(this.disp(this.unitsNet(v))), strike: hasPct ? fmtMoney(this.disp(v.len * this.unit(v))) : '' }, // riferimento = prezzo pieno: badge e barrato tornano
        hasPct ? `<span class="zw-bb__badge">−${pct}%</span>` : '', false);
      // niente "minimo N m" a destra (2026-10-29): in quella posizione l'altra card ha il prezzo e si leggeva
      // come tale, e il minimo e' gia' nella pillola "Ordine minimo" sotto il prezzo e nell'errore
      const part = this.choiceRow('part', i.partCut,
        esc(canPart ? (sameM ? '' : tpl(i.perMeter, { price: fmtMoney(this.disp(this.tm(v))) })) : tpl(i.errMin, { min: this.minM * 2 })),
        null, '', !canPart);
      let upsellHtml = '';
      if (st.choice === 'part' && canPart && !val.error && val.m) {
        const u = this.upsell(v, val.m);
        if (u) upsellHtml = `<div class="zw-bb__upsell"><span>${esc(u.text)}</span><button type="button" class="zw-bb__green" data-zw-action="take-roll" data-zw-id="${u.cand.id}">${esc(tpl(i.takeRoll, { meters: fmtLen(u.cand.len) }))}</button></div>`;
      }
      let suggestHtml = '';
      if (st.choice === 'part' && val.suggest) {
        const s = val.suggest;
        if (s.kind === 'roll') {
          suggestHtml = `<div class="zw-bb__suggest"><span>${esc(tpl(i.forMeters, { meters: s.m }))}</span><div class="zw-bb__suggest-actions">` +
            `<button type="button" class="zw-bb__pill" data-zw-action="cut-from" data-zw-id="${s.cand.id}">${esc(tpl(i.cutFrom, { meters: fmtLen(s.cand.len) }))}</button>` +
            (s.m <= v.len ? `<button type="button" class="zw-bb__pill" data-zw-action="take-roll" data-zw-id="${v.id}"><span>${esc(tpl(i.wholeThis, { price: fmtMoney(this.disp(this.unitsNet(v))) }))}</span>${hasPct ? `<span class="zw-bb__badge zw-bb__badge--mini">−${pct}%</span>` : ''}</button>` : '') + `</div></div>`;
        } else {
          const w = s.cand;
          const save = this.cutNet(v, s.m) - this.unitsNet(w);
          // testo del pulsante in uno span: il pulsante e' inline-flex con gap, e se uno script esterno
          // avvolge una parte del prezzo in un suo elemento il gap finiva dentro il numero ("56 3,64 €", 2026-10-28)
          suggestHtml = `<div class="zw-bb__suggest"><span>${esc(tpl(i.needMeters, { meters: s.m, roll: fmtLen(w.len), more: fmtLen(w.len - s.m), amount: fmtMoney(this.disp(Math.max(save, 0))) }))}</span><div class="zw-bb__suggest-actions">` +
            `<button type="button" class="zw-bb__pill" data-zw-action="take-roll" data-zw-id="${w.id}"><span>${esc(tpl(i.takeRoll, { meters: fmtLen(w.len) }))}, ${fmtMoney(this.disp(this.unitsNet(w)))}</span>${hasPct ? `<span class="zw-bb__badge zw-bb__badge--mini">−${pct}%</span>` : ''}</button></div></div>`;
        }
      }
      el.hidden = false;
      // il minimo sta nella pillola "Ordine minimo" sotto il prezzo: niente doppione nell'intestazione
      el.innerHTML = `<div class="zw-bb__label"><span>${esc(i.heading)}</span></div><div class="zw-bb__choices">` +
        full + this.partBlock(part, canPart ? this.metersField(val, quick, suggestHtml + upsellHtml, true) : '') + `</div>`;

      function validateOrEmpty(self) {
        return self.state.choice === 'part' ? self.validateMeters() : { m: null, error: null };
      }
    }
    // riga-opzione (radio): price = {value, strike}; subHtml gia' escapato da chi chiama (puo' contenere <s>)
    choiceRow(key, title, subHtml, price, badge, disabled) {
      const on = this.state.choice === key;
      const priceHtml = price && price.value
        ? `<span class="zw-bb__choice-price${price.strike ? ' is-sale' : ''}"><strong>${price.value}</strong>${price.strike ? `<s>${price.strike}</s>` : ''}</span>`
        : '';
      return `<button type="button" class="zw-bb__choice${on ? ' is-selected' : ''}" data-zw-choice="${key}" role="radio" aria-checked="${on}" ${disabled ? 'disabled' : ''}>` +
        `<span class="zw-bb__radio" aria-hidden="true"></span>` +
        `<span class="zw-bb__choice-main"><span class="zw-bb__choice-title">${esc(title)}${badge || ''}</span><span class="zw-bb__choice-sub">${subHtml}</span></span>` +
        priceHtml + `</button>`;
    }
    // "solo una parte": opzione + campo metri nello stesso riquadro
    partBlock(choiceHtml, fieldHtml) {
      const on = this.state.choice === 'part';
      return `<div class="zw-bb__part${on ? ' is-selected' : ''}">${choiceHtml}${on ? fieldHtml : ''}</div>`;
    }
    // campo metri con +/−; quick = scelte rapide. showQuick: pillole prima del campo (taglio); al metro le
    // scelte sono i chip della griglia, qui servono solo a non evidenziare il campo come "personalizzato"
    metersField(val, quick, extra, showQuick = false) {
      const i = this.i18n;
      const st = this.state;
      const m = parseInt(st.meters, 10);
      const isQuick = quick.includes(m);
      const cls = val.error && st.metersTouched ? ' is-error' : !isQuick && st.meters !== '' ? ' is-custom' : '';
      let lo = 1;
      let hi = Infinity;
      if (this.mode === 'meter') {
        lo = this.meterMin;
        hi = this.meterMax(st.color);
      }
      else if (this.current()) {
        lo = this.minM;
        hi = Math.max(this.maxGlobal(st.color), this.maxPart(this.current()));
      }
      const atLo = !isNaN(m) && m <= lo;
      const atHi = !isNaN(m) && m >= hi;
      return `<div class="zw-bb__meters${cls}"><div class="zw-bb__meters-row">` +
        (showQuick && quick.length ? quick.map((n) => `<button type="button" class="zw-bb__chip${m === n ? ' is-selected' : ''}" data-zw-quick="${n}">${n} m</button>`).join('') : '') +
        `<label class="zw-bb__field"><span>${esc(this.mode === 'meter' ? i.otherMeters : i.meters)}</span>` +
        `<span class="zw-bb__stepper"><button type="button" class="zw-bb__step" data-zw-step="-1" aria-label="−" ${atLo ? 'disabled' : ''}>−</button>` +
        `<input type="number" inputmode="numeric" min="${lo}" step="1" value="${esc(st.meters)}" data-zw-meters>` +
        `<button type="button" class="zw-bb__step" data-zw-step="1" aria-label="+" ${atHi ? 'disabled' : ''}>+</button></span><span class="zw-bb__unit">m</span></label>` +
        `</div>` +
        (val.error && st.metersTouched ? `<p class="zw-bb__error">${esc(val.error)}</p>` : '') + (extra || '') + `</div>`;
    }
    renderTotal() {
      const i = this.i18n;
      const t = this.computeTotal();
      const v = this.current();
      const soldOut = !this.colorAvailable(this.state.color) || (this.mode === 'meter' && this.meterAvail(this.state.color) < this.meterMin);
      this.el.totalNote.textContent = i.vatNote;
      // una riga sola, "Totale per 3 pelli (4,2 m²)" / "Totale per 2 rotoli (60 m)" / "Totale per 12 m" e il
      // prezzo (2026-10-29, versione minimal, pelli e tessuti): niente dettaglio sotto e niente "IVA inclusa"
      // (gia' accanto al prezzo in alto). La quantita' e' nell'etichetta: non si confonde con la disponibilita'
      const ok = t && !t.error;
      let what = '';
      if (ok && this.leather) {
        const area = this.data.showArea ? (t.variant.area || 0) * t.qty : 0;
        what = (t.qty === 1 ? i.totHideOne : tpl(i.totHides, { count: t.qty })) + (area > 0 ? ` (${fmtLen(area)} m²)` : '');
      } else if (ok) {
        const rollsN = this.mode === 'roll' ? t.qty : t.tipo === 'intero' ? 1 : 0;
        const metersN = tpl(i.totMeters, { meters: fmtLen(this.mode === 'roll' ? t.qty * t.variant.len : this.mode === 'meter' ? t.qty : t.metri) });
        what = rollsN > 0 ? `${rollsN === 1 ? i.totRollOne : tpl(i.totRolls, { count: rollsN })} (${metersN})` : metersN;
      }
      if (this.el.totalLabel) this.el.totalLabel.textContent = what ? tpl(i.totalFor, { hides: what }) : i.total;
      this.el.totalNote.textContent = '';
      if (!t || t.error) {
        this.el.totalValue.textContent = '—';
        this.el.totalValue.classList.add('is-empty');
        this.el.totalDesc.textContent = t && t.error ? t.error : this.leather ? i.chooseHide : i.chooseRoll;
      } else {
        this.el.totalValue.textContent = fmtMoney(this.disp(t.net));
        this.el.totalValue.classList.remove('is-empty');
        this.el.totalDesc.textContent = ''; // tutto nell'etichetta
        // pelli a fasce: pieno barrato sotto il totale scontato
        if (t.full > t.net) this.el.totalNote.innerHTML = `<s class="zw-bb__total-old">${fmtMoney(this.disp(t.full))}</s>`;
        // al metro, se ne hai gia' nel carrello: "in totale 30 m nel carrello" sotto il prezzo
        if (this.mode === 'meter') {
          const l = this.line(t.variant);
          if (l && l.qty > 0) this.el.totalNote.textContent = tpl(i.inCartTotal, { meters: fmtLen(l.qty + t.qty) });
        }
      }
      this.renderTiers();
      // form nascosto: variante, quantita', properties
      if (t && !t.error) {
        this.el.inputId.value = t.variant.id;
        this.el.inputQty.value = t.qty || 1;
        if (this.el.propTipo) {
          this.el.propTipo.disabled = this.el.propMetri.disabled = this.el.propTotali.disabled = false;
          this.el.propTipo.value = t.tipo;
          this.el.propMetri.value = t.metri;
          this.el.propTotali.value = t.variant.len;
        }
      } else if (this.el.propTipo) {
        this.el.propTipo.disabled = this.el.propMetri.disabled = this.el.propTotali.disabled = true;
      }
      // bottone: disabled vero solo per esaurito (Huski lo legge), aria-disabled per "manca la scelta"
      const add = this.el.add;
      if (this._flash) return; // durante la conferma verde non si tocca l'etichetta
      add.classList.remove('is-success');
      if (soldOut) {
        add.disabled = true;
        add.setAttribute('aria-disabled', 'true');
        this.el.addLabel.textContent = i.soldOut;
        return;
      }
      // rotolo intero: se del rotolo scelto non resta niente fuori dal carrello, il bottone
      // non ha niente da aggiungere (Shopify rifiuterebbe comunque)
      if (this.mode === 'roll' && v) {
        const l = this.line(v);
        if (v.qty - (l ? l.qty : 0) <= 0) {
          add.disabled = true;
          add.setAttribute('aria-disabled', 'true');
          this.el.addLabel.textContent = i.inCart;
          return;
        }
      }
      add.disabled = false;
      const ready = !!(t && !t.error);
      add.setAttribute('aria-disabled', ready ? 'false' : 'true');
      const sameAsCart = ready && this.isSameAsCart(t);
      if (!t) this.el.addLabel.textContent = this.leather ? i.chooseHide : i.chooseRoll;
      else this.el.addLabel.textContent = this.state.editingKey ? i.update : i.add;
      if (sameAsCart) add.setAttribute('aria-disabled', 'true');
    }
    isSameAsCart(t) {
      if (this.mode !== 'cut' || !this.state.editingKey) return false;
      const l = this.line(t.variant);
      return !!(l && l.key === this.state.editingKey && l.tipo === t.tipo && Math.abs((l.metri || 0) - t.metri) < 0.001);
    }

    // ---------- carrello: scrittura ----------
    cartEl() {
      return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    }
    async cartRequest(path, body) {
      const cart = this.cartEl();
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      const res = await fetch(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw data;
      return data;
    }
    afterCartWrite(data, variantId) {
      const cart = this.cartEl();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zw-buy-box', productVariantId: variantId, cartData: data });
      }
      if (cart && typeof cart.renderContents === 'function' && data.sections) {
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        const inner = cart.querySelector('.drawer__inner');
        if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        cart.renderContents(data);
      }
    }
    async submit() {
      const add = this.el.add;
      if (add.disabled || add.getAttribute('aria-disabled') === 'true' || this._busy) return;
      const t = this.computeTotal();
      if (!t || t.error) return;
      this._busy = true;
      add.classList.add('is-loading');
      this.showMsg('');
      const v = t.variant;
      try {
        let data;
        const editing = this.mode === 'cut' && this.state.editingKey;
        if (editing) {
          // una riga per rotolo, aggiornata in una sola richiesta: niente finestra senza riga
          data = await this.cartRequest('/cart/change.js', {
            id: this.state.editingKey,
            quantity: 1,
            properties: { _tipo: t.tipo, _metri_acquistati: t.metri, _metri_totali: v.len },
          });
        } else if (this.mode === 'cut') {
          const existing = this.line(v);
          if (existing && existing.key) {
            data = await this.cartRequest('/cart/change.js', {
              id: existing.key,
              quantity: 1,
              properties: { _tipo: t.tipo, _metri_acquistati: t.metri, _metri_totali: v.len },
            });
          } else {
            data = await this.cartRequest('/cart/add.js', {
              id: v.id,
              quantity: 1,
              properties: { _tipo: t.tipo, _metri_acquistati: t.metri, _metri_totali: v.len },
            });
          }
        } else {
          data = await this.cartRequest('/cart/add.js', { id: v.id, quantity: t.qty || 1 });
        }
        this.afterCartWrite(data, v.id);
        await this.fetchCart();
        // l'animazione parte DOPO il render finale (altrimenti la griglia ricostruita la cancella)
        this._pendingFlash = { label: editing ? this.i18n.updated : this.i18n.added, v, desc: t.desc };
        if (this.mode === 'cut') {
          // un rotolo per volta: quello appena preso resta "nel carrello", si passa al prossimo libero
          this.state.editingKey = null;
          this.state.meters = '';
          this.state.metersTouched = false;
          this.state.note = '';
          this.preselect();
        } else if (this.mode === 'meter') {
          this.state.note = '';
        }
      } catch (err) {
        await this.fetchCart();
        this.reconcileSelection();
        const gone = this.mode !== 'meter' && !this.purchasable(this.byId(v.id));
        this.showMsg((err && err.description) || (gone ? (this.leather ? this.i18n.hideGone : this.i18n.rollGone) : this.i18n.addError));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, { source: 'zw-buy-box', productVariantId: v.id, errors: err && err.description, message: err && err.message });
        }
      } finally {
        this._busy = false;
        add.classList.remove('is-loading');
        this.render();
        if (this._pendingFlash) {
          const f = this._pendingFlash;
          this._pendingFlash = null;
          this.flash(f.label, f.v);
          this.toast(f.label + ': ' + f.desc);
        }
      }
    }
    async removeLine() {
      const key = this.state.editingKey;
      if (!key || this._busy) return;
      this._busy = true;
      try {
        const v = this.current();
        const l = this.line(v);
        const desc = l && l.tipo === 'intero' ? tpl(this.i18n.totalFull, { meters: fmtLen(v.len) }) : tpl(this.i18n.totalPart, { meters: l ? Math.round(l.metri) : '', roll: v ? fmtLen(v.len) : '' });
        const data = await this.cartRequest('/cart/change.js', { id: key, quantity: 0 });
        this.afterCartWrite(data, this.state.rollId);
        await this.fetchCart();
        this.toast(this.i18n.removed + ': ' + desc);
        this.state.editingKey = null;
        this.state.rollId = null;
        this.state.meters = '';
        this.state.metersTouched = false;
      } catch (err) {
        await this.fetchCart();
        this.showMsg(this.i18n.addError);
      } finally {
        this._busy = false;
        this.render();
      }
    }
    showMsg(text) {
      const el = this.el.msg;
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
    }
    // toast nero in basso (prototipo): 2,6 s
    toast(text) {
      if (!text) return;
      let el = document.querySelector('.zw-bb__toast');
      if (!el) {
        el = document.createElement('div');
        el.className = 'zw-bb__toast';
        el.setAttribute('role', 'status');
        document.body.appendChild(el);
      }
      el.textContent = text;
      el.classList.add('is-on');
      clearTimeout(this._toastT);
      this._toastT = setTimeout(() => el.classList.remove('is-on'), 2600);
    }
    // conferma: bottone verde ~1,1 s + alone sul rotolo (spec §9); con reduced motion solo colore
    flash(label, v) {
      const add = this.el.add;
      this._flash = true;
      add.classList.add('is-success');
      this.el.addLabel.textContent = label;
      const target = this.mode === 'meter' ? (this.el.grid.querySelector('.is-selected') || this.el.rollsMeta) : this.el.grid.querySelector(`[data-zw-roll="${v.id}"]`);
      if (target) {
        target.classList.remove('is-flash');
        void target.offsetWidth; // riavvia l'animazione anche se la classe era appena stata tolta
        target.classList.add('is-flash');
        setTimeout(() => target.classList.remove('is-flash'), 700);
      }
      setTimeout(() => {
        this._flash = false;
        add.classList.remove('is-success');
        this.render();
      }, 1100);
    }
  }

  customElements.define('zw-buy-box', ZwBuyBox);
})();